import React from 'react';
import { useLanguage } from '../../../API/Context/LanguageContext';
import { LanguageEnum } from '../../../Types/Enums/LanguageEnum';
import { VocabLanguageSelector } from '../../../ConfigFiles/multilingual/VocabLanguageSelector';

export const LanguageSelector = () => {
    const { lan, setLan } = useLanguage();

    return (
        <select 
            value={lan} 
            onChange={(e) => setLan(Number(e.target.value))}
            className="border p-2 rounded bg-white text-black"
        >
            <option value={LanguageEnum.SPANISH}>{VocabLanguageSelector.spanish[lan]}</option>
            <option value={LanguageEnum.ENGLISH}>{VocabLanguageSelector.english[lan]}</option>
        </select>
    );
};